import { OperationBC, OperationLienBC } from '../types';

// Commandes complementaires cote acheteur : regles pures, sans React.

/** Une principale n'a pas de parente. Seule une principale peut recevoir un complement. */
export const estPrincipale = (operation: OperationBC): boolean => !operation.id_operation_parente;

/**
 * Lignes du tableau : la principale en premier (la page elle-meme, ou sa parente depuis un
 * complement), puis ses complements dans l'ordre de creation.
 */
export const lignesComplements = (operation: OperationBC): OperationLienBC[] => {
  if (estPrincipale(operation)) {
    const { id, numero, nom, cree_par, createur, prix_total, created_at } = operation;
    const principale: OperationLienBC = {
      id, numero, nom, cree_par, createur, prix_total, created_at,
      statut: operation.status?.nom,
    };
    return [principale, ...(operation.complementaires ?? [])];
  }
  const parente = operation.parente;
  return parente ? [parente, ...(parente.complementaires ?? [])] : [];
};

/**
 * Libelle du champ « Type de commande » du descriptif : la base porte 'initial' sur un bon classique
 * et « Complémentaire N°X au <numero de la principale> » sur un complement.
 */
export const libelleTypeCommande = (typeCommande?: string | null): string =>
  !typeCommande || typeCommande === 'initial' ? 'Initiale' : typeCommande;
